/**
 * 雪花 ID 超过 Number.MAX_SAFE_INTEGER（2^53-1），
 * JSON.parse 会先把数字转成 IEEE754，精度已丢，reviver 救不回来。
 * 解析前把超长整型 ID 改成字符串。
 */
const SNOWFLAKE_ID_KEYS = [
  'rescueId',
  'riskId',
  'peopleId',
  'userId',
  'assigneeUserId',
  'fileId',
  'emergencyId',
  'devId',
  'tenantId',
  'parentId',
  'staffId',
  'articleId',
  'discussId',
  'productDeviceId',
  'deviceId',
  'templateId',
  'exceptionId',
  'eventListId',
  'createId',
  'updateId',
].join('|')

const SNOWFLAKE_ID_RE = new RegExp(`"(${SNOWFLAKE_ID_KEYS})"\\s*:\\s*(\\d{16,})`, 'g')

export function parseApiJson(raw: string) {
  const quoted = raw.replace(SNOWFLAKE_ID_RE, '"$1":"$2"')
  return JSON.parse(quoted)
}
